export default {
  updateTrialsDisciplines({ commit }, cgList) {
    let list = [];
    let creative = [];
    if (cgList.length) {
      this.$api("getEntranceTestsDisciplines", { competitiveGroups: cgList }, "POST")
        .then(result => {
          if (result.data['EntranceTestsDisciplines'].length) {

            result.data['EntranceTestsDisciplines'].forEach(item => {
              if (item['IS_CREATIVE']) {
                creative.push(item['ID']);
              } else {
                list.push({
                  "id": item['ID'],
                  'label': item['NAME']
                })
              }
            })

            commit('UPDATE_TRIALS_DISCIPLINES', { list, creative });
          } else {
            commit('UPDATE_TRIALS_DISCIPLINES', { list, creative });
          }
        }).catch(e => commit('UPDATE_TRIALS_DISCIPLINES', { list, creative }))

    } else {
      commit('UPDATE_TRIALS_DISCIPLINES', { list, creative });
    }
  },
  setStep({ commit }, step) {
    commit('SET_STEP', step);

    if (step === 18) {
      commit('FILTER_CAMPUSES');
    }
  },
  clearValue({ commit }, path) {
    let pathWay = path.split('_');

    if (pathWay.length !== 3) {
      return;
    }

    commit('CLEAR_VALUE', pathWay);
  },
  changeBlock({ commit }, params) {
    commit('CHANGE_BLOCK', params);
  },
  updateLastStepBlockFields({ commit }, fields) {
    commit('UPDATE_LAST_STEP_BLOCK_FIELDS', fields);
  },
  set({ commit }, list) {
    commit('SET', list);
    let reqSteps = [];

    list.forEach(item => {

      if (item.required) {
        reqSteps.push(Number(item.number));
      }
    });

    commit('SET_REQUIRED_STEPS', reqSteps);
  },
  setUserId({ commit }, params) {
    commit("SET_USERID", params);
  },
  blockOlympicFields({ commit }) {
    commit('BLOCK_OLYMPIC_FIELDS');
  },
  unblockOlympicFields({ commit }) {
    commit('UNBLOCK_OLYMPIC_FIELDS');
  },
  deleteDataFromLocalStorage() {
    const keys = Object.keys(localStorage);

    keys.forEach(key => {

      if (key.includes('mb/')
        || key.includes('file/')
        || key.includes('field/')
        || key.includes('checkbox/')
        || key.includes('/competitiveGroups')
      ) {
        localStorage.removeItem(`${key}`);
      }
    })

  },
  setStatus({ commit }, params) {
    commit('SET_STATUS', params);
  },
  clearValidationErrors({ commit }) {
    commit("CLEAR_ERRORS");
  },
  setValidationErrors({ commit }, params) {
    commit("SET_ERRORS", params);
  },
  async actionButtonBase({ commit }, params) {
    commit('ACTION_BUTTON_BASE', params);
  },
  async competitionGroupUpdate({ commit }, params) {
    commit('UPDATE_COMPETITION_GROUP', params);
  },
  async competitionGroupSelect({ commit }, params) {
    await commit('SELECT_COMPETITION_GROUP', params);
    commit('FILTER_CAMPUSES');
    commit('REFRESH_TRIGGER_PROGRAM');
  },
  async competitionGroupUnselect({ commit }, params) {
    await commit('UNSELECT_COMPETITION_GROUP', params);
    commit('FILTER_CAMPUSES');
    commit('REFRESH_TRIGGER_PROGRAM');
  },
  setCompetitiveGroups({ commit }, params) {
    commit("SET_COMPETITIVE_GROUP", params);
    commit("SET_SELECTED_ITEM", params);
    const item = params?.find((e) => e.budgetPriority !== '' || e.commercePriority !== '')
    if (item) {
      this.commit('applicationData/setChangePriorityPlace', true)
    }
  },
  async setSelectedCompatition({ commit }) {
    await commit('SET_SELECTED_COMPETITION');
    commit('FILTER_CAMPUSES');
  },
  handleInitEvent({ commit }) {
    commit('INIT_EVENT');
  },
  async actionButtonCustom({ commit }, params) {
    if (!params.target) {
      return;
    }

    switch (params.target) {
      case "register_residency":
        commit('ACTION_BUTTON_REGISTER_RESIDENCY', params);
        break;
      case "recognition":
        commit('ACTION_BUTTON_RECOGNITION', params);
        break;
      case "hse_student":
        commit('ACTION_BUTTON_HSE_STUDENT', params);
        break;
    }
  },
  async save({ commit }, params) {
    commit('SAVE', params);
  },
  async update({ commit }, params) {
    // when input on text field (just change value in store, no more!!)
    commit('UPDATE', params);
  },
  setFieldItemValue({ commit }, { options, values }) {
    commit('SET_ITEM_VALUES', { options, values })
  },
  mapFields({ getters }, fields) {
    const mode = getters['getAppFormViewMode'];
    for (let i = 0; i < fields.length; i++) {
      let isStepProhibitionEdit = false

      if (mode === 'view') {
        fields[i].blocks.forEach((b) => {
          b.prohibition_edit = true
        })
        isStepProhibitionEdit = !fields[i].blocks.find((e) => !e.prohibition_edit)
      }
      fields[i].prohibition_edit = fields[i].prohibition_edit ?? isStepProhibitionEdit
    }
    return fields
  },
  mapPrintFormsToValKey(context, value) {
    if (Array.isArray(value)) {
      return value.map((e) => ({
        value: e.file,
        key: e.placeType
      }))
    }
    return []
  },
  async saveFile({ commit }, params) {
    return new Promise(async (resolve, reject) => {

      if (params.realFile) {
        let files = [];

        if (Array.isArray(params.realFile)) {

          for (const file of params.realFile) {
            let formData = new FormData();
            formData.append('FILE', file);

            await this.$api("uploadFile", formData, "POST")
              .then(result => {
                files.push({ ...result.data.file });
              })
              .catch(err => console.error(err));
          }
        } else {
          let formData = new FormData();
          formData.append('FILE', params.realFile);

          await this.$api("uploadFile", formData, "POST")
            .then(result => {
              files.push({ ...result.data.file, realFile: params.realFile });
            })
            .catch(err => console.error(err));
        }

        params.files = files;
        delete params.realFile;
      }

      commit('SAVE_FILE', params);
      resolve(params.files);
    })

  },
  async initFields({ state, dispatch, commit, getters }) {
    if (state.isInitFields) {
      return;
    }

    commit('SET_INIT_FIELDS', true)


    const response = await this.$api('application')

    const fields = await dispatch('mapFields', response.data.fields)
    await dispatch('set', fields);
    await dispatch('setRefs', response.data.refs);
    const printForms = await dispatch('mapPrintFormsToValKey', response.data.printForms)
    commit('SET_SAVED_FILES', printForms);
    const list = getters['getList'];


    if (Array.isArray(list)) {
      list.forEach((field, fieldIndex) => {
        if (Array.isArray(field.blocks)) {
          field.blocks.forEach((block, blockIndex) => {
            if (Array.isArray(block.items)) {
              block.items.forEach((item, itemIndex) => {
                if (item.value) {
                  dispatch('save', {
                    value: item.value,
                    path: `${fieldIndex}_${blockIndex}_${itemIndex}`,
                    mode: 'start'
                  });
                }
              });
            }
          });
        }
      });
    }

    if (list[0].blocks[0].items[0].hasOwnProperty('value') && list[0].blocks[0].items[0].value) {
      await dispatch('save', {
        value: list[0].blocks[0].items[0].value,
        path: '0_0_0',
        mode: 'start'
      })
    }

    if (response.data.hasOwnProperty('multiBlocks')) {
      await this.dispatch('multiBlocks/setBlocksWithData', {
        multiBlocks: response.data.multiBlocks,
        competitiveGroups: response.data?.competitiveGroups ?? [],
      });
      await dispatch('handleInitEvent');
    }

    if (response.data.hasOwnProperty('competitiveGroups')) {
      await this.dispatch('needHelp/setLink', 'edit');
      await this.dispatch('needHelp/setIsEdit', true);
      await dispatch('setCompetitiveGroups', response.data.competitiveGroups);
      const selectedCompetitions = []
      response.data.competitiveGroups.forEach((e) => {
        if (e.guid) {
          selectedCompetitions.push({
            idCompetitiveGroup: e.id,
            xmlIdCompetiveGroup: e.guid
          })
        }
      })
      if (selectedCompetitions.length) {
        commit('INIT_SELECTED_COMPETITION_GUID', selectedCompetitions)
        this.dispatch('applicationData/initPriorityPlace', { responseCompetitiveGroups: response.data.competitiveGroups })
      }
    }
  },
  setFile({ commit }, params) {
    commit("SAVE_FILE", params);
  },
  deleteFile({ commit }, params) {
    commit("DELETE_FILE", params)
  },
  async setRefs({ commit }, data) {
    commit('SET_REFS', data);
  },
  setValuesToMultiBlocks({ dispatch, state }, params) {
    const codes = state.codesWhenUpdate;

    let getAllValues = function (items) {
      const arrayWithPromises = [];
      const ruYear = params.items.filter(field => field.code === "OLYMPIAD_RU_YEAR")[0];
      const ruYearValue = params.values.filter(field => field.code === "OLYMPIAD_RU_YEAR")[0]?.value;

      const data = {
        "OLYMPIAD_LIST_PROFILE": params.values.filter(field => field.code === "OLYMPIAD_LIST_OLYMPIAD")[0]?.value,
        "OLYMPIAD_RU_PROFILE": ruYear?.values?.filter(field => field.id === ruYearValue)[0]?.label,
      }

      for (let i = 0; i < items.length; i++) {

        if (codes.includes(items[i].code)) {
          const value = params.values.filter(field => field.code === items[i].code)[0];

          const result = dispatch('updateSelectValues', {
            path: params.path + '_' + i,
            code: items[i].code,
            value: value.value,
            mode: "start",
            data: data.hasOwnProperty(items[i].code) ? data[items[i].code] : ""
          })
            .then((response) => {
              return { code: `${items[i].code}`, items: response?.data?.items ?? [] }
            })

          arrayWithPromises.push(result);
        }
      }

      return Promise.all(arrayWithPromises);
    };

    return getAllValues(params.items);
  },
  setValueToMultiBlocks({ commit }, params) {
    commit('UPDATE_SELECT_VALUES', params);
  },
  async updateSelectValues({ commit, state }, params) {
    let filter = {};
    params.values = [];
    let pathWay = params.path.split('_');

    if (pathWay.length !== 3) {
      return;
    }

    let thisYearValueIndex;
    let thisBlock = state.fields[pathWay[0]].blocks[pathWay[1]];
    let thisField = thisBlock.items[pathWay[2]];
    let action = "getOlympicFilter";

    switch (params.code) {
      case "OLYMPIAD_LIST_YEAR":
        thisYearValueIndex = thisField.values.findIndex(item => item.id === params.value);
        if (thisYearValueIndex !== -1) {
          filter = {
            'year': thisField.values[thisYearValueIndex].label
          }
        }
        break;
      case "OLYMPIAD_LIST_OLYMPIAD":
        filter = {
          'olympic': params.value
        }

        break;
      case "OLYMPIAD_LIST_PROFILE":
        let olympicFieldIndex = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_LIST_OLYMPIAD");
        if (olympicFieldIndex !== -1) {

          if (!params.hasOwnProperty('mode')) {
            filter = {
              'olympic': thisBlock.items[olympicFieldIndex].value,
              'profile': params.value
            }
          } else {
            filter = {
              'olympic': params.data,
              'profile': params.value
            }
          }
        }
        break;
      case "OLYMPIAD_RU_YEAR":
        action = "getOlympicFilterRu";
        thisYearValueIndex = thisField.values.findIndex(item => item.id === params.value);
        if (thisYearValueIndex !== -1) {
          filter = {
            'year': thisField.values[thisYearValueIndex].label
          }
        }
        break;
      case "OLYMPIAD_INTERNATIONAL_YEAR":
        action = "getOlympicFilterInternational";
        thisYearValueIndex = thisField.values.findIndex(item => item.id === params.value);
        if (thisYearValueIndex !== -1) {
          filter = {
            'year': thisField.values[thisYearValueIndex].label
          };
        }
        break;
      case "OLYMPIAD_UKR_YEAR":
        action = "getOlympicFilterUkr";
        thisYearValueIndex = thisField.values.findIndex(item => item.id === params.value);
        if (thisYearValueIndex !== -1) {
          filter = {
            'year': thisField.values[thisYearValueIndex].label
          };
        }
        break;
      case "OLYMPIAD_RU_PROFILE":
        action = "getOlympicFilterRu";
        let yearFieldIndex = thisBlock.items.findIndex(item => item.code === "OLYMPIAD_RU_YEAR");
        if (yearFieldIndex !== -1) {

          if (!params.hasOwnProperty('mode')) {
            thisYearValueIndex = thisBlock.items[yearFieldIndex].values.findIndex(item => item.id === thisBlock.items[yearFieldIndex].value);

            if (thisYearValueIndex !== -1) {
              filter = {
                'year': thisBlock.items[yearFieldIndex].values[thisYearValueIndex].label,
                'profile': params.value
              }
            }
          } else {
            filter = {
              'year': params.data,
              'profile': params.value
            }
          }
        }
        break;
      case "TARGETED_DIRECTION":
        action = "getEduProgramsFilter";
        let campusFieldIndex = thisBlock.items.findIndex(item => item.code === "TARGETED_CAMPUS");
        if (campusFieldIndex !== -1) {
          filter = {
            'campus': thisBlock.items[campusFieldIndex].value,
            'speciality': params.value
          }
        }
        break;
      case "ACHIEVEMENT_CATHEGORY":
        action = "getAchievementsFilter";
        filter = {
          "category": params.value
        };
        break;

    }


    if (Object.keys(filter).length) {
      if (!params.mode) {
        return await this.$api(action, { filter }, "POST").then(response => {
          params.values = response.data.items
          commit('UPDATE_SELECT_VALUES', params);
          commit('UNBLOCK_OLYMPIC_FIELDS');
          return Promise.resolve(response.data)
        })
          .catch(() => commit('UPDATE_SELECT_VALUES', params))

      } else {
        return await this.$api(action, { filter }, "POST");
      }
    } else {
      commit('UPDATE_SELECT_VALUES', params);
    }
  },
  selectTargetForCompetition({ commit }, params) {
    commit('SELECT_TARGET_FOR_COMPETITION', params)
  },
  selectQuotaForCompetition({ commit }, params) {
    commit('SELECT_QUOTA_FOR_COMPETITION', params);
  },
  selectExtraForCompetition({ commit }, params) {
    commit('SELECT_EXTRA_FOR_COMPETITION', params);
  },
  selectSpecialisation({ commit }, params) {
    if (Array.isArray(params)) {
      params.forEach((e) => {
        commit('SELECT_SPECIALISATION', e)
      })
    } else {
      commit('SELECT_SPECIALISATION', params);
    }
  },
  selectProgramEdu({ commit }, params) {
    if (Array.isArray(params)) {
      params.forEach((e) => {
        commit('SELECT_EDU_PROGRAMS', e)
      })
    } else {
      commit('SELECT_EDU_PROGRAMS', params);
    }
  },
  setGuidSelectedCompetition({ commit }, params) {
    commit('SET_GUID_SELECTED_COMPETITION', params)
  },
  resetValuesByChangedStep({ commit, state, getters }, params) {
    const targetItemsByStep = [
      '0_9_0' // Форма согласия на обработку персональных данных
    ]

    const targetItems = [
      '18_0', // Формы в конце заполнения шагов
    ]

    let path = []
    let pathBySteps = []
    const arrParamsPath = params.path?.split('_') ?? []


    if (arrParamsPath.length === 3) {
      pathBySteps = targetItemsByStep.find((e) => {
        const [fieldIndex, _, __] = e.split('_')
        return fieldIndex == arrParamsPath[0]
      })?.split('_') ?? []
    }

    targetItems.forEach((e) => {
      const arr = e.split('_')

      if (arr.length === 2) {
        const [fieldIndex, blockIndex] = arr
        const blocks = state.fields[fieldIndex]?.blocks
        const items = blocks[blockIndex]?.items

        items?.forEach((e, i) => {
          if (e.value) {
            path.push([fieldIndex, blockIndex, i])
          }
        })
      }
    })


    if (pathBySteps.length) {
      commit('CLEAR_VALUE', pathBySteps)
    }

    if (path.length) {
      path.forEach((e) => {
        commit('CLEAR_VALUE', e)
      })
    }
  },
  setFormState({ commit, dispatch, state, getters }, { options, value }) {
    if (!state.isChangedForm && getters['getAppFormViewMode'] !== 'view') {
      commit('SET_CHANGED_FORM_STATE', value);
      dispatch('resetValuesByChangedStep', options);
    }
  },
  setFormViewMode({ commit, state, rootGetters }, value) {
    const checkNewMode = (mode) => {
      return rootGetters['getAvailModes'].includes(mode);
    }

    const newMode = checkNewMode(value) ? value : rootGetters['getViewMode'];

    if (state.formViewMode !== newMode) {
      commit('step-15/setDataIsSet', false, { root: true });
      commit('SET_INIT_FIELDS')
      commit('SET_FORM_VIEW_MODE', newMode)
    }
  }
};
